// extracted by mini-css-extract-plugin
export default {"app":"App_app__zr1wm","footer":"App_footer__aawhi"};